export const getFieldSuggestionAiAttributes = (singleInstrumentationID: string) => {
	return {
		aiFeatureName: 'jiraFieldSuggestions',
		userGeneratedAI: 0,
		proactiveAIGenerated: 1,
		isAIFeature: 1,
		singleInstrumentationID,
		// TODO: Make this more modular when we suggest more field types
		fieldSuggestionType: 'labels',
	};
};
